import React from "react";
import { Card, CardContent } from "./ui/card";
import { PlaceHolderImages } from "../lib/placeholder-images";

interface TeamMember {
  id: string;
  name: string;
  designation: string;
  bio: string;
}

const teamMembers: TeamMember[] = [
  {
    id: "team-member-ihab",
    name: "Ihab K A Bashir",
    designation: "Assistant General Manager",
    bio: "With exceptional leadership and a results-driven mindset, Ihab aligns the company’s strategic goals with operational execution.",
  },
  {
    id: "team-member-abba",
    name: "Abba Oumar",
    designation: "Manager of Sales, Marketing, and Customer Relations",
    bio: "His strategic foresight, proactive customer-centric approach and innovative outlook have elevated the company’s market presence.",
  },
  {
    id: "team-member-husain",
    name: "Hussain Samad",
    designation: "Finance Manager",
    bio: "Hussain is the driving force behind the financial strength and stability of the company, ensuring sustainable growth and resilience in a dynamic market.",
  },
  {
    id: "team-member-fateh",
    name: "Abdulaziz Fateh",
    designation: "IT Manager",
    bio: "He has been the cornerstone of all IT-related operations, guaranteeing seamless network performance, robust data solutions, and digital resilience across all departments.",
  },
];

export const TeamSection: React.FC = () => {
  return (
    <div className="w-full">
      {/* Section Header */}
      <div className="text-center mb-12 gsap-wwa-team-title">
        <h2 className="text-[#e71875] font-semibold mb-2">OUR CREATIVE TEAM</h2>
        <h3 className="text-4xl md:text-5xl font-bold text-neutral-800">
          Meet Our Team of Experts
        </h3>
        <p className="mt-4 text-lg text-muted-foreground max-w-3xl mx-auto">
          The dedicated professionals driving our success and delivering
          exceptional visa solutions.
        </p>
      </div>

      {/* Team Members Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-x-8 gap-y-24 pt-20">
        {teamMembers.map((member) => {
          const image = PlaceHolderImages.find((p) => p.id === member.id);

          return (
            <div
              key={member.id}
              className="text-center flex flex-col items-center gsap-wwa-team-card"
            >
              {/* Profile Image */}
              {image && (
                <div className="relative mb-[-90px]">
                  <img
                    src={image.imageUrl}
                    alt={`Portrait of ${member.name}`}
                    width={180}
                    height={180}
                    className="rounded-full object-cover aspect-square border-2 border-[#e71875]  p-1"
                    data-ai-hint={image.imageHint}
                  />
                </div>
              )}

              {/* Card Content */}
              <Card className="border-2 !border-[#e71875]  bg-white rounded-xl text-center pt-28 h-full">
                <CardContent className="p-6">
                  <h4 className="text-xl font-bold text-neutral-800">
                    {member.name}
                  </h4>
                  <p className="text-[#e71875] font-semibold mt-1">
                    {member.designation}
                  </p>
                  <p className="text-muted-foreground mt-3 text-sm">
                    {member.bio}
                  </p>
                </CardContent>
              </Card>
            </div>
          );
        })}
      </div>
    </div>
  );
};
